__turbopack_context__.v({
  "archidekt": "icon-module-scss-module___SfoXa__archidekt",
  "battlefield": "icon-module-scss-module___SfoXa__battlefield",
  "commandZone": "icon-module-scss-module___SfoXa__commandZone",
  "exile": "icon-module-scss-module___SfoXa__exile",
  "graveyard": "icon-module-scss-module___SfoXa__graveyard",
  "hand": "icon-module-scss-module___SfoXa__hand",
  "icon": "icon-module-scss-module___SfoXa__icon",
  "library": "icon-module-scss-module___SfoXa__library",
});
